import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Button from '../Button';

// "26–50 z 134" with previous / next buttons
const Pager = ({ total, page, pageSize, onPage }) => {
  if (!total) return null;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className="shp-pager" aria-label="Stránkování">
      <span className="shp-num" role="status">Zobrazeno {from}–{to} z {total}</span>
      <div className="shp-pager__btns">
        <Button variant="secondary" icon={ChevronLeft} disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Předchozí stránka">Předchozí</Button>
        <span className="shp-num" aria-current="page">{page} / {pages}</span>
        <Button variant="secondary" icon={ChevronRight} iconPosition="right" disabled={page >= pages} onClick={() => onPage(page + 1)} aria-label="Další stránka">Další</Button>
      </div>
    </nav>
  );
};

export default Pager;
